export default __webpack_public_path__ + "static/media/icon-info.eec3d68c.svg";